import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

export default function Hero() {
  return (<section className="hero bg-dark">
    <Container className="center-text vh-100 pb-5">
      <Row className="align-items-end pb-5">
        <Col>
          <h1>Iryna Slynko</h1>
          <h3>Software Engineer</h3>
        </Col>
      </Row>
    </Container>
  </section>);
}